import { render, staticRenderFns } from "./ToggleTrashed.vue?vue&type=template&id=ded57b40&"
import script from "./ToggleTrashed.vue?vue&type=script&lang=js&"
export * from "./ToggleTrashed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports